import Page from "gui/DiscoverTeamsPage/DiscoverTeamsPage";
import type { GetStaticProps } from "next";

import {
  getListDiscoverTeamsToPopulateCache,
  usePopulateListDiscoverTeamsCache,
  ListDiscoverTeamsCacheDataItem,
} from "gui/DiscoverTeamsPage/api/cacheListDiscoverTeams";

interface Props {
  listDiscoverTeamsCacheData: ListDiscoverTeamsCacheDataItem[];
  expiresAt: number;
}

export default function PagesBrowseTeams(props: Props) {
  const { listDiscoverTeamsCacheData, expiresAt } = props;

  usePopulateListDiscoverTeamsCache(listDiscoverTeamsCacheData, { expiresAt });

  return <Page />;
}

export const getStaticProps: GetStaticProps<Props> = async () => {
  const firstPage = await getListDiscoverTeamsToPopulateCache({
    filter: { freetext: "" },
    page: 1,
    pageSize: 20,
  });

  return {
    props: {
      listDiscoverTeamsCacheData: [firstPage],
      expiresAt: Date.now() + 2.5 * 60 * 1000, // Expires after 2.5 minutes (ok if it's a little stale)
    },
    revalidate: 2 * 60, // 2 minute cache
  };
};
